"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfoStepToJSON = exports.PersonalInfoStepFromJSONTyped = exports.PersonalInfoStepFromJSON = void 0;
const _1 = require("./");
function PersonalInfoStepFromJSON(json) {
    return PersonalInfoStepFromJSONTyped(json, false);
}
exports.PersonalInfoStepFromJSON = PersonalInfoStepFromJSON;
function PersonalInfoStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'biographicInfo': _1.PreBiographicInfoStepFromJSON(json['biographicInfo']),
        'contact': _1.PreContactStepFromJSON(json['contact']),
    };
}
exports.PersonalInfoStepFromJSONTyped = PersonalInfoStepFromJSONTyped;
function PersonalInfoStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'biographicInfo': _1.PreBiographicInfoStepToJSON(value.biographicInfo),
        'contact': _1.PreContactStepToJSON(value.contact),
    };
}
exports.PersonalInfoStepToJSON = PersonalInfoStepToJSON;
//# sourceMappingURL=PersonalInfoStep.js.map